<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.itemName"
              placeholder="请输入项目名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.search.searchDate" />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        :total-amount="totalAmount"
        :is-show-total="isShowTotal"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
        @getTotal="totalFun"
      />
    </div>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 日期选择
import DateSelect from '@/components/DateSelect'
// 数据请求
import { loadCrossBorderSellServiceItemListDataApi, loadCrossBorderSellServiceItemExportDataApi } from '@/api/crossBorderSell'
export default {
  name: 'CrossBorderSellServiceItem',
  components: {
    CustomTable,
    TableOperation,
    DateSelect
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'cross_marketing_service_item_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['cross_border_sell_service_item_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            schemeNo: '',
            itemName: '',
            searchDate: ''
          }
        }
      },
      id: null, // 选中的单据ID
      totalAmount: 0, // 合计结果
      isShowTotal: false // 合计显示
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'c.province_name', width: 80 },
      { prop: 'cityName', label: '城市', filterColumn: 'c.city_name', width: 80 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 's.project_no', width: 200 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 's.name', width: 200 },
      { prop: 'activityDateStr', label: '实际执行时间', filterColumn: 'c.activity_date', width: 140, isBetween: true },
      { prop: 'userNames', label: '实际执行人', filterColumn: 'if(c.partner_ids != \'\',concat(c.executor_name,\',\',c.partner_names),c.executor_name)', width: 160 },
      { prop: 'executeDateStr', label: '痕迹化时间', filterColumn: 'c.execute_date', width: 120, isBetween: true },
      { prop: 'executorNames', label: '痕迹化人员', filterColumn: 'c.executor_names', width: 160 },
      { prop: 'compereNames', label: '主持人员', filterColumn: 'c.compere_names', width: 160 },
      { prop: 'ceremonialNames', label: '礼仪人员', filterColumn: 'c.ceremonial_names', width: 160 },
      { prop: 'typeStr', label: '服务类型', filterColumn: 'csi.type', filterValue: 'type', filterArray: [{ label: '终端运维', value: 1 }, { label: '人员服务', value: 2 }, { label: '宣传展示（服务类）', value: 3 }, { label: '宣传展示（制作类）', value: 4 }, { label: '色彩终端', value: 5 }, { label: '品系宣介', value: 6 }, { label: '其他费用', value: 7 }, { label: '场地租赁', value: 8 }], width: 140 },
      { prop: 'name', label: '服务名称', filterColumn: 'i.name', width: 160 },
      { prop: 'unit', label: '单位', filterColumn: 'i.unit', width: 110 },
      { prop: 'itemPrice', label: '单价', filterColumn: 'csi.price', width: 100, isBetween: true },
      { prop: 'amount', label: '数量', filterColumn: 'i.amount', width: 100, isBetween: true, allowSum: true },
      { prop: 'total', label: '合计', filterColumn: 'round(csi.price * i.amount, 2)', width: 100, formatPrice: true, allowSum: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadCrossBorderSellServiceItemListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 合计方法
    totalFun (fieldColumn, computedTotalObj) {
      this.masterList.tableLoading = true
      let sumCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      sumCondition.isSumTotal = true
      sumCondition.sumField = computedTotalObj.filterColumn
      loadCrossBorderSellServiceItemListDataApi(sumCondition).then(response => {
        this.masterList.tableLoading = false
        this.isShowTotal = true
        this.totalAmount = response.data ? response.data.sumTotal : 0
      }).catch()
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadCrossBorderSellServiceItemExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
